module.exports = __webpack_public_path__ + "img/right-boy1.fbfd6b39.svg";